import Card from '@ui/Card';
import CardContent from '@ui/CardContent';
import Grid from '@ui/Grid';
import { lightGreyColor } from '@ui/styles/colors';
import FormFieldRecapItem from './FormFieldRecapItem';
import { IFormFieldRecapItemContactComponentProperties } from './types';
import { recapGridItemStyle, recapCardStyle, recapCardContentStyle } from './styles';

const FormFieldRecapItemContact = ({
    label,
    value,
    link,
    inverted,
} : IFormFieldRecapItemContactComponentProperties) => (
    <Grid item xs="auto" style={recapGridItemStyle}>
        <Card elevation={0} style={{ ...recapCardStyle, ...(inverted && { backgroundColor: lightGreyColor }) }}>
            <CardContent style={recapCardContentStyle}>
                <FormFieldRecapItem
                    label={label}
                    link={link}
                    value={value}
                />
            </CardContent>
        </Card>
    </Grid>
);

export default FormFieldRecapItemContact;

